import React from "react";
import { Link } from "react-router-dom";
import * as CONFIG from "./../pages/_config";
import ls from "local-storage";
const axios = require("axios");

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      socialmediasettings: [],
      dataLoaded: false,
      intrlv: false,
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => this.checkFooterLoaded(), 500);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  checkFooterLoaded() {
    let dataLoaded = ls.get("dataLoaded");
    if (dataLoaded) {
      window.clearInterval(this.interval);
      this.setState({ dataLoaded: true });
    } else {
      this.setState({ dataLoaded: false });
    }
  }

  render() {
    let socialicons = null;

    if (this.state.dataLoaded) {
      socialicons = CONFIG.DATA.socialmediasettings;
    }

    if (socialicons) {
      socialicons.sort(function (a, b) {
        return a.SequenceNumber - b.SequenceNumber;
      });
    }

    const SocialIconAvailable =
      false ||
      (socialicons &&
        socialicons.filter((x) => x.IsSocialMedia === true && x.Value !== "")
          .length > 0);
    // console.log("SocialIconAvailable", SocialIconAvailable);

    const client = CONFIG.DATA.BACKEND_HOST
    const supportTime = CONFIG.DATA.SUPPORT_TIME
    const supportPhone = CONFIG.DATA.SUPPORT_PHONE

    return (
      <React.Fragment>
        {CONFIG.DATA.THEME === 1 ? (
          <div className="footer footer-1">
            {CONFIG.DATA.ONLY_COUPONS !== true ? (
              <div
                className="site-section ftco-subscribe-1 footer-static"
                style={{ padding: "2.5em 0" }}
              >
                <div className="container">
                  {client === "renfroes" ? (
                    <div className="text-center">
                      <a
                        href={`mailto:${CONFIG.DATA.SUPPORT_EMAIL}`}
                        style={{ color: "#000" }}
                      >
                        <h5 style={{ color: "#90815b", fontSize: "15px" }}>
                          <i
                            className="icon-envelope"
                            style={{ paddingRight: "10px", fontFamily: "20px" }}
                          ></i>
                          DO YOU HAVE A QUESTION?
                        </h5>
                      </a>
                    </div>
                  ) : (
                    <div
                      className="row align-items-center"
                      style={{ textAlign: "left" }}
                    >
                      <div className="col-lg-4 col-xs-12">
                        {supportPhone &&
                          supportPhone != "" &&
                          supportTime &&
                          supportTime != "" && (
                            <>
                              <h5
                                style={{ color: "#90815b", fontSize: "15px" }}
                              >
                                <i
                                  className="icon-phone"
                                  style={{
                                    paddingRight: "10px",
                                    fontFamily: "20px",
                                  }}
                                ></i>
                                DO YOU HAVE A QUESTION?
                              </h5>
                              {client === "heritagemarket" ? (
                                <>
                                  <span
                                    style={{
                                      color: "#000",
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      display: "block",
                                    }}
                                  >
                                    <i
                                      className="icon-location-arrow"
                                      style={{
                                        paddingRight: "8px",
                                        fontSize: "22px",
                                      }}
                                    ></i>
                                    180 South Elm AvenueEaton,
                                    <h4
                                      style={{
                                        marginLeft: "25px",
                                        color: "#000",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        display: "block",
                                      }}
                                    >
                                      Colorado 80615
                                    </h4>
                                  </span>
                                </>
                              ) : (
                                ""
                              )}
                              <p style={{ color: "#000" }}>
                                <strong>
                                  {client === "themarketplace" ? (
                                    <>Cokato: {supportPhone}</>
                                  ) : client === "buchefoods" ? (
                                    <>{`605-384-4300`}</>
                                  ) : (
                                    <>{supportPhone}</>
                                  )}
                                  <br />

                                  {client === "buchefoods" ? (
                                    <>({`8 AM to 5 PM`})</>
                                  ) : supportTime &&
                                    supportTime != "" && 
                                    client !== "almichsmarket" ? (
                                    `(${supportTime})`
                                  ) : (
                                    ""
                                  )}
                                </strong>
                              </p>
                              {client === "millers" ? (
                                <p style={{ color: "#000" }}>
                                  Or call your local store location!
                                </p>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                      </div>
                      <div className="col-lg-2 col-xs-12">
                        <h5 style={{ color: "#90815b", fontSize: "15px" }}>
                          <i
                            className="icon-envelope"
                            style={{ paddingRight: "10px", fontFamily: "20px" }}
                          ></i>
                          OFFER QUESTION?
                        </h5>
                      </div>
                      <div className="col-lg-2 col-xs-12">
                        <p style={{ fontSize: "14px" }}>
                          <a
                            href={`mailto:${CONFIG.DATA.SUPPORT_EMAIL}`}
                            style={{ color: "#000" }}
                          >
                            Click Here
                          </a>
                        </p>
                      </div>

                      <div className="col-lg-2 col-xs-12">
                        <h5 style={{ color: "#90815b", fontSize: "15px" }}>
                          <i
                            className="icon-support"
                            style={{ paddingRight: "10px", fontFamily: "20px" }}
                          ></i>
                          SUPPORT QUESTION?
                        </h5>
                      </div>
                      <div className="col-lg-2 col-xs-12">
                        <p style={{ fontSize: "14px" }}>
                          <a
                            href={`mailto:${CONFIG.DATA.SUPPORT_EMAIL_STORE}`}
                            style={{ color: "#000" }}
                          >
                            Click Here
                          </a>
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
            <div
              className="footer"
              style={{
                padding: "1rem 0",
                background: "#fff",
                fontSize: "12px",
                color: "#848484",
              }}
            >
              <div className="container">
                <div className="row">
                  <div
                    className="col-md-12  col-xs-12"
                    style={{ padding: "10px" }}
                  >
                    {" "}
                    {CONFIG.DATA.COMPANY_POLICIES &&
                      CONFIG.DATA.COMPANY_POLICIES.length > 0 ? (
                      <div className="row">
                        <span
                          style={{ marginRight: "10px", marginLeft: "10px" }}
                        >
                          <Link
                            title="Privacy Policy"
                            className="font-size-15px"
                            style={{
                              color: "#000",
                              fontWeight: "700",
                              fontSize: "13px",
                            }}
                            to="/company-policies/privacy-policy"
                          >
                            Privacy Policy
                          </Link>
                        </span>{" "}
                        |{" "}
                        <span
                          style={{ marginRight: "10px", marginLeft: "10px" }}
                        >
                          <Link
                            title="Terms & Conditions"
                            className="font-size-15px"
                            style={{
                              color: "#000",
                              fontWeight: "700",
                              fontSize: "13px",
                            }}
                            to="/company-policies/terms-and-conditions"
                          >
                            Terms & Conditions
                          </Link>
                        </span>{" "}
                        |{" "}
                        <span
                          style={{ marginRight: "10px", marginLeft: "10px" }}
                        >
                          <Link
                            title="Web Accessssibility"
                            className="font-size-15px"
                            style={{
                              color: "#000",
                              fontWeight: "700",
                              fontSize: "13px",
                            }}
                            to="/company-policies/web-accessibility"
                          >
                            Web Accessibility
                          </Link>
                        </span>
                        {
                          CONFIG.DATA.RSA_SUBDOMAIN === 'sunshinefoodstores'
                            || CONFIG.DATA.RSA_SUBDOMAIN === 'lawrencebros'

                            ? (
                              <>
                                | {" "}
                                < span style={{ marginRight: "10px", marginLeft: "10px" }}>
                                  <Link
                                    title="Rewards Program Policy"
                                    className="font-size-15px"
                                    style={{
                                      color: "#000",
                                      fontWeight: "700",
                                      fontSize: "13px",
                                      paddingLeft: "2px"
                                    }}
                                    to="/company-policies/rewards-program-policy"
                                  >
                                    Rewards Program Policy
                                  </Link>
                                </span>
                              </>) : ("")
                        }
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {/* <div
                    className="col-md-4  col-xs-12"
                    style={{ padding: "7px" }}
                  > */}
                  {/* <p style={{ marginTop: "0px" }}>
                      Copyright &copy; RSA America LLC{" "}
                      {/*CONFIG.DATA.RSA_CLIENT_APP_NAME
                      {new Date().getFullYear()} &nbsp;&nbsp;
                    </p> */}
                  {/* </div> */}

                  {/* <div
                    className="col-md-4  col-xs-12"
                    style={{ padding: "7px" }}
                  >
                    <span style={{ fontSize: "0.6rem" }}>
                      <a
                        href="https://rsaamerica.com/"
                        title="Powered by RSA America"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Powered by{" "}
                        <img
                          loading="lazy"
                          src={CONFIG.DATA.LOGO_FOOTER}
                          alt="Footer Logo"
                          className="img-fluid"
                          style={{ maxWidth: "250px", maxHeight: "35px" }}
                        />
                      </a>
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="footer footer-1 apus-footer mt-2">
            {CONFIG.DATA.ONLY_COUPONS !== true ? (
              <div
                className=""
                style={{
                  padding: "1px",
                  // background: `url("${CONFIG.DATA.BG_FOOTER}") repeat scroll 0 0 / 100% 100%`
                  background:
                    CONFIG.DATA.BG_FOOTER_OR_COLOR.indexOf("#") === 0
                      ? CONFIG.DATA.BG_FOOTER_OR_COLOR
                      : `url("${CONFIG.DATA.BG_FOOTER_OR_COLOR}")  repeat scroll 0 0 / 100% 100%`,
                }}
              >
                <div className="container">
                  <div className="row justify-content-center mt-2 mb-3">
                    <div
                      className={"col-md-" + (SocialIconAvailable ? 3 : 5)}
                      style={{ paddingLeft: "0px" }}
                    >
                      <div className="wpb_wrapper">
                        <div className="widget widget-social  right style2">
                          <h3 className="title">
                            <span>
                              <b>About Us:</b>
                            </span>
                          </h3>
                          <div className="widget-content">
                            <ul className="social"></ul>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element  vc_custom_1558715153809">
                          <div className="wpb_wrapper text-left">
                            <p
                              className="text-left font-size-15px"
                              style={{
                                fontSize: "14px",
                                maxHeight: "160px",
                                overflow: "hidden",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: CONFIG.DATA.ABOUT_FOOTER,
                              }}
                            ></p>
                            <Link
                              className=""
                              title="Know More"
                              to="/about"
                              rel="noopener noreferrer"
                              style={{ fontSize: "14px", color: "#000" }}
                            >
                              Know More...
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    {SocialIconAvailable ? (
                      <div className="col-md-3">
                        <div className="wpb_wrapper">
                          <div className="widget widget-social  right style2">
                            <h3 className="title">
                              <span>
                                <b>FOLLOW US:</b>
                              </span>
                            </h3>
                            <div className="widget-content">
                              <ul className="social list-unstyled  bo-sicolor pull-right">
                                {
                                  // (socialicon)
                                  socialicons &&
                                  socialicons.map((val, index) => {
                                    if (
                                      val.IsSocialMedia === true &&
                                      val.Value !== ""
                                    ) {
                                      return (
                                        <li key={index}>
                                          <a
                                            title={val.Title}
                                            href={val.Value}
                                            className={val.Title.toLowerCase()}
                                            target="_blank"
                                          >
                                            <i
                                              className={
                                                "fa fa-" +
                                                val.Title.toLowerCase() +
                                                " bo-social-" +
                                                val.Title.toLowerCase() +
                                                ""
                                              }
                                            >
                                              &nbsp;
                                            </i>
                                            <span className="hidden">
                                              {val.Title}
                                            </span>
                                          </a>
                                        </li>
                                      );
                                    }
                                  })
                                }
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="col-md-3">
                      <div className="wpb_wrapper">
                        <div className="widget widget-social  right style2">
                          <h3 className="title">
                            <span>
                              <b>MORE LINKS:</b>
                            </span>
                          </h3>
                          <div className="widget-content">
                            <ul
                              className="footer-links list-inline"
                              style={{ textAlign: "left", listStyle: "none" }}
                            >
                              <li>
                                <Link
                                  title="About Us"
                                  to="/about"
                                  className="font-size-15px"
                                >
                                  About Us
                                </Link>
                              </li>
                              <li>
                                <Link
                                  title="Coupons"
                                  to="/coupons"
                                  className="font-size-15px"
                                >
                                  Coupons
                                </Link>
                              </li>
                              {client !== "pruetts" ? (
                                <li>
                                  <Link
                                    title="Weekly Ads"
                                    to="/weekly-ads"
                                    className="font-size-15px"
                                  >
                                    Weekly Ads
                                  </Link>
                                </li>
                              ) : (
                                ""
                              )}
                              <li>
                                <Link
                                  title="Locations"
                                  to="/contact"
                                  className="font-size-15px"
                                >
                                  Locations
                                </Link>
                              </li>
                              <li>
                                <Link
                                  title="Contact Us"
                                  to="/contact"
                                  className="font-size-15px"
                                >
                                  Contact Us
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <img
                        title={CONFIG.DATA.RSA_CLIENT_APP_NAME}
                        alt="footer logo"
                        style={{ marginTop: "50px" }}
                        src={CONFIG.DATA.LOGO_BOTTOM}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="vc_row-full-width vc_clearfix"></div>
            <div className="vc_row wpb_row vc_row-fluid footer-copyright">
              <div className="container wpb_column vc_column_container">
                <div className="vc_column-inner" style={{ padding: "0px" }}>
                  <div className="wpb_wrapper">
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper col-md-12">
                        <div className="row">
                          <div
                            className="col-md-12  col-xs-12"
                            style={{ padding: "10px" }}
                          >
                            {" "}
                            {CONFIG.DATA.COMPANY_POLICIES &&
                              CONFIG.DATA.COMPANY_POLICIES.length > 0 ? (
                              <div className="row">
                                <div className="col-md-10  col-xs-12">
                                  <span style={{ padding: "2px" }}>
                                    <Link
                                      title="Privacy Policy"
                                      className="font-size-15px"
                                      style={{
                                        color: "#fff",
                                        fontWeight: "600",
                                        fontSize: "13px",
                                      }}
                                      to="/company-policies/privacy-policy"
                                    >
                                      Privacy Policy
                                    </Link>
                                  </span>{" "}
                                  |{" "}
                                  <span style={{ padding: "2px" }}>
                                    <Link
                                      title="Terms & Conditions"
                                      className="font-size-15px"
                                      style={{
                                        color: "#fff",
                                        fontWeight: "600",
                                        fontSize: "13px",
                                      }}
                                      to="/company-policies/terms-and-conditions"
                                    >
                                      Terms & Conditions
                                    </Link>
                                  </span>{" "}
                                  |{" "}
                                  <span style={{ padding: "2px" }}>
                                    <Link
                                      title="Web Accessssibility"
                                      className="font-size-15px"
                                      style={{
                                        color: "#fff",
                                        fontWeight: "600",
                                        fontSize: "13px",
                                      }}
                                      to="/company-policies/web-accessibility"
                                    >
                                      Web Accessibility
                                    </Link>
                                  </span>

                                  {CONFIG.DATA.RSA_SUBDOMAIN === 'sunshinefoodstores'
                                    || CONFIG.DATA.RSA_SUBDOMAIN === 'lawrencebros'
                                    ? (
                                      <>
                                        | {" "}
                                        < span style={{ padding: "2px" }}>
                                          <Link
                                            title="Rewards Program Policy"
                                            className="font-size-15px"
                                            style={{
                                              color: "#fff",
                                              fontWeight: "600",
                                              fontSize: "13px",
                                            }}
                                            to="/company-policies/rewards-program-policy"
                                          >
                                            Rewards Program Policy
                                          </Link>
                                        </span>
                                      </>) : ("")
                                  }
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          {/* <div
                            className="col-md-3  col-xs-12"
                            style={{ padding: "7px" }}
                          >
                            <p style={{ marginTop: "0px" }}>
                              Copyright &copy; RSA America LLC{" "}
                              {/*CONFIG.DATA.RSA_CLIENT_APP_NAME
                              {new Date().getFullYear()} &nbsp;&nbsp;
                            </p>
                          </div> */}

                          {/* <div
                            className="col-md-4  col-xs-12"
                            style={{ padding: "1px" }}
                          >
                            <span
                              style={{ fontSize: "13px", marginTop: "0px" }}
                            >
                              <a
                                href="https://rsaamerica.com/"
                                title="Powered by RSA America"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Powered by{" "}
                                <img
                                  loading="lazy"
                                  src={CONFIG.DATA.LOGO_FOOTER}
                                  alt="Footer Logo"
                                  className="img-fluid"
                                  style={{
                                    maxWidth: "250px",
                                    maxHeight: "35px",
                                  }}
                                />
                              </a>
                            </span>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
        }
      </React.Fragment>
    );
  }
}
export default Footer;
